<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title>Formüller</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-text-field v-model="search" append-icon="search" label="Ara" single-line hide-details></v-text-field>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-btn color="primary" dark @click="initialize" class="mb-2">Ara</v-btn>
      <v-btn color="primary" dark class="mb-2" to="/poolFormula/detail">Yeni Ekle</v-btn>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :loading="this.$store.state.progress"
      :rows-per-page-items="pageItems"
      :items="this.$store.state.poolFormulas.all"
      :pagination.sync="pagination"
      :search="search"
      class="elevation-1"
    >
      <template v-slot:headers="props">
        <tr>
          <th
            v-for="header in props.headers"
            :key="header.text"
            class="px-0 text-xs-center"
            :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
            @click="changeSort(header.value)"
          >
            {{ header.text }}
            <v-icon small>arrow_upward</v-icon>
          </th>
        </tr>
      </template>
      <template v-slot:items="props">
        <td class="px-0 text-xs-center">{{ props.item.id }}</td>
        <td class="px-0 text-xs-center">{{ props.item.name }}</td>
        <td class="px-0 text-xs-center">{{ props.item.formula }}</td>
        <td class="px-0 text-xs-center">{{ props.item.order }}</td>
        <td class="px-0 text-xs-center">
          <v-icon small class="mr-2" @click="editItem(props.item)">edit</v-icon>
          <v-icon small @click="deleteItem(props.item)">delete</v-icon>
        </td>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-data-table>
  </div>
</template>
<script>
export default {
  data: () => ({
    pagination: {
      sortBy: "order"
    },
    select: { id: -1, value: "Tümü" },
    search: null,
    pageItems: [
      25,
      50,
      { text: "$vuetify.dataIterator.rowsPerPageAll", value: -1 }
    ],
    items: [
      { id: -1, value: "Tümü" },
      { id: 0, value: "Pasif" },
      { id: 1, value: "Aktif" }
    ],
    headers: [
      {
        text: "Id",
        align: "left",
        value: "id"
      },
      { text: "Formül Adı", value: "name" },
      { text: "Formül", value: "formula" },
      { text: "Sıra", value: "order" },
      { text: "İşlem", value: "name", sortable: false }
    ]
  }),
  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  created() {
    //this.initialize();
  },

  methods: {
    async initialize() {
      await this.$store.dispatch("poolFormulas/searchFormula", {
        search: this.search,
        state: this.select.id
      });
    },
    editItem(item) {
      this.$router.push({ name: "formula-detail", params: { id: item.id } });
    },

    deleteItem(item) {
      confirm("Silmek İstediğinizden Emin Misiniz?") &&
        this.$store.dispatch("poolFormulas/deleteFormula", item);
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    }
  },
  async mounted() {
    await this.initialize();
  }
};
</script>